import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from 'app/interceptors/auth.interceptor';
import { AuthExpiredInterceptor } from 'app/interceptors/auth-expired.interceptor';
import { ErrorHandlerInterceptor } from 'app/interceptors/error-handler.interceptor';
import { NotificationInterceptor } from 'app/interceptors/notification.interceptor';
import { BotHandlerInterceptor } from 'app/interceptors/bot-handler.interceptor';

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthExpiredInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorHandlerInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: NotificationInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: BotHandlerInterceptor,
    multi: true,
  },
];
